import React from "react";

const STEPS = [
  {
    title: "Register your interest",
    body: (
      <>
        All you need to do is simply contact us to register your interest at{" "}
        <a href="mailto:secretaryraf9456@gmail.com">secretaryraf9456@gmail.com</a>.
      </>
    ),
  },
  {
    title: "Fill in a form",
    body: (
      <>We will then contact you and ask you to complete a short form.</>
    ),
  },
  {
    title: "Meeting us",
    body: (
      <>
        After receiving your short form, arrangements will be made to meet you socially
        to find out more about you, and to give you a chance to find out more about us.
      </>
    ),
  },
  {
    title: "Initiation",
    body: (
      <>
        You would then in due course be invited to meet a committee of Past Masters from
        our Lodge prior to being balloted for membership. All being well, a date would
        then be fixed for your admission.
      </>
    ),
  },
];

function JoinSteps() {
  return (
    <div className="steps">
      {STEPS.map((s, i) => (
        <div className="step" key={s.title}>
          <div className="step__num">{String(i + 1).padStart(2, "0")}</div>
          <div>
            <h3>{s.title}</h3>
            <p>{s.body}</p>
          </div>
        </div>
      ))}
    </div>
  );
}

export default JoinSteps;
